import { getUltheraEvidenceReviews } from '../_data/evidence'

/**
 * 울쎄라 회복·다운타임 페이지가 사용하는 검수 완료 정적 데이터.
 *
 * 원본: 울쎄라_100자이상_전체_260825.csv
 * 집계: 2026-08-25
 * 작성자명과 병원명은 소비자 화면에 전달하지 않는다.
 */
export const ultheraRecoveryCorpus = {
  validReviewCount: 13_478,
  duplicateTextCount: 149,
  excludedRowCount: 8,
  sourceCount: 5,
  sourceBadges: ["N", "G", "K", "M", "Y"],
  reviewPeriod: "2018.06.08~2026.08.25",
  countedAt: "2026.08.25",
} as const

export const ultheraRecoveryTableOfContents = [
  { id: "section-01", title: "받고 바로, 붓거나 얼얼했다는 말이 같이 나와요" },
  { id: "section-02", title: "붓기 없던 사람도, 꽤 부은 사람도 있었어요" },
  { id: "section-03", title: "멍은 없었다는 말도, 붉은기가 남았다는 말도 있어요" },
  { id: "section-04", title: "겉은 괜찮아 보여도 얼얼함은 따로 남았어요" },
  { id: "section-05", title: "바로 출근하고 화장한 사람도 있었어요" },
  { id: "section-06", title: "“일주일이면 끝”이라고 단정할 수는 없었어요" },
] as const

export const ultheraRecoverySections = [
  {
    id: "section-01",
    number: "01",
    keyword: "울쎄라 시술 직후",
    titleLines: ["받고 바로,", "붓거나 얼얼했다는 말이 같이 나와요"],
    body: "시술 직후 반응은 한 가지가 아니었어요. 붉은기와 열감이 잠깐 있었다는 사람, 턱이 얼얼했다는 사람, 붓기가 거의 없었다는 사람이 함께 나왔거든요. 그래서 ‘직후엔 이렇다’고 하나로 묶기보다 실제로 적힌 느낌을 나란히 봤습니다.",
    quote: "울쎄라하고 약간 붉은기랑 열감있지만 금방 가라앉았고 살짝 뻐근한 느낌 있었는데 이것도 하루이틀지나니 사라졌습니다!",
    quoteSource: "네이버 지도 · 2026.08",
    evidence: "거울에 보이는 붓기와 내가 느끼는 얼얼함은 따로 확인하는 게 좋아요.",
    variant: "first" as const,
  },
  {
    id: "section-02",
    number: "02",
    keyword: "울쎄라 붓기",
    titleLines: ["붓기 없던 사람도,", "꽤 부은 사람도 있었어요"],
    body: "같은 울쎄라인데 붓기 후기는 정확히 갈렸어요. 점심시간에 받고 오후 업무를 했다는 사람이 있는 반면, 당일에는 얼굴이 꽤 부었다고 적은 사람도 있었어요. 다만 그 사람도 다음 날에는 화장과 일상생활이 가능했다고 남겼습니다.",
    quote: "붓기도 거의없어서 오후업무 바로 됐고요",
    quoteSource: "네이버 지도 · 2026.07",
    evidence: "다음 날 중요한 일정이 있다면, 시술받아도 괜찮을지 병원에 한 번 더 물어보세요.",
  },
  {
    id: "section-03",
    number: "03",
    keyword: "울쎄라 멍·붉은기",
    titleLines: ["멍은 없었다는 말도,", "붉은기가 남았다는 말도 있어요"],
    body: "멍이 하나도 들지 않았다는 후기도 있었고, 살짝 생겼다가 금방 없어졌다는 후기도 있었어요. 붉은기와 열감은 금방 가라앉았다고 적은 사람이 있었고요. ‘사흘째 멍이 올라온다’처럼 특정 날짜로 묶을 만큼 같은 경험이 반복되지는 않았습니다.",
    quote: "살짝 따끔하긴한데 견딜만하구 멍도 하나도 안들었어요!!",
    quoteSource: "구글 지도 · 2026.08",
    evidence: "멍이 ‘언제 생기나’보다, 생겼을 때 얼마나 남았는지를 확인하는 편이 더 현실적이었어요.",
  },
  {
    id: "section-04",
    number: "04",
    keyword: "울쎄라 얼얼함·감각",
    titleLines: ["겉은 괜찮아 보여도", "얼얼함은 따로 남았어요"],
    body: "붓기가 적은데도 턱이 얼얼했다는 후기가 있었어요. 수면으로 받아 시술 중 통증은 몰랐지만 끝난 뒤에는 조금 얼얼했다는 사람도 있었고요. 겉으로 보이는 회복과 만졌을 때 느껴지는 감각은 같은 속도로 돌아오지 않았습니다.",
    quote: "끝나고 약간 얼얼한느낌정도만 있고 붓기 많이없어서",
    quoteSource: "네이버 지도 · 2026.08",
    evidence: "마스크로 가릴 수 있는 문제와, 만졌을 때 남는 느낌은 따로 봐야 해요.",
  },
  {
    id: "section-05",
    number: "05",
    keyword: "울쎄라 일상 복귀",
    titleLines: ["바로 출근하고", "화장한 사람도 있었어요"],
    body: "점심시간에 울쎄라를 받고 오후 업무로 돌아간 사람, 시술 직후에도 일상생활이 가능했다는 사람, 바로 관광을 갔다는 사람까지 있었어요. 반대로 당일 붓기가 꽤 있었다는 후기도 있으니, ‘다운타임 없음’을 모든 사람의 결과처럼 쓰지는 않았습니다.",
    quote: "울쎄라인데 붓기도 거의없어서 오후업무 바로 됐고요",
    quoteSource: "네이버 지도 · 2026.07",
    evidence: "출근은 가능해도 중요한 촬영이나 행사는 다를 수 있어요. 필요한 건 ‘일상 가능’보다 내 일정 기준입니다.",
    variant: "start" as const,
  },
  {
    id: "section-06",
    number: "06",
    keyword: "울쎄라 회복기간",
    titleLines: ["“일주일이면 끝”이라고", "단정할 수는 없었어요"],
    body: "하루이틀 뒤 자연스러워졌다는 후기도 있었지만, 일주일째 광대가 살짝 욱신거렸다는 사람도 있었어요. 턱이 2주 넘게 얼얼했지만 점차 좋아졌다는 직접 경험도 있었고요. 지금 연결한 개인 경험만으로 모든 사람의 회복 기간을 정할 수는 없습니다.",
    quote: "턱 부분이 2주 넘게 좀 얼얼?했지만 점차 좋아지고 있어요",
    quoteSource: "네이버 지도 · 2025.08",
    evidence: "남의 회복 날짜에 맞추기보다, 내 증상이 줄어드는지 계속되는지를 보는 게 더 중요해요.",
  },
] as const

export const ultheraRecoveryStory = {
  title: "한 사람의 하루이틀",
  label: "실제 후기 1건",
  beats: [
    { stage: "받은 직후", lines: ["약간의 붉은기와 열감이 있었다."] },
    { stage: "같은 날", lines: ["살짝 뻐근한 느낌이 남았다."] },
    { stage: "하루이틀", lines: ["붉은기와 뻐근함이 가라앉았다."] },
  ],
  quote: "울쎄라하고 약간 붉은기랑 열감있지만 금방 가라앉았고 살짝 뻐근한 느낌 있었는데 이것도 하루이틀지나니 사라졌습니다!",
  quoteSource: "네이버 지도 · 2026.08",
  takeaway: "이 분은 붉은기와 뻐근함이 하루이틀 지나 사라졌어요.",
} as const

export const ultheraRecoveryEvidenceReviews = getUltheraEvidenceReviews('recovery')

export const ultheraRecoveryEvidenceCount = ultheraRecoveryEvidenceReviews.length
